module.exports = __webpack_public_path__ + "static/media/featured-1-bed-sc.bd93d172.png";